import React from "react"

import { Wrapper, Heading, Text } from "./styles"

const Summary = ({ element }) => (
  <Wrapper>
    <Heading id={`mbg-${element.anchor}`}>{element.title || "Summary"}</Heading>
    <Text
      dangerouslySetInnerHTML={{
        __html: element.text,
      }}
    />
  </Wrapper>
)

export default Summary
